<div class="campaign-details-page records-page--campaigns">
  <div class="card card-custom campaign-details-shell details-page-shell">
    <div class="card-body">
        <div class="details_top">
          <div class="details-page-heading">
            <div class="details-page-heading__primary">
              <span class="details-page-heading__eyebrow">{{ 'CAMPAIGN_DETAILS' | translate }}</span>
            </div>
            <div class="details-page-heading__actions" *ngIf="isAdmin || doWhat.canWrite || doWhat.canDelete">
              <button *ngIf="isAdmin || doWhat.canWrite" type="button" class="orange-button" (click)="editCampaign()">{{ 'EDIT_CAMPAIGN' | translate }}</button>
              <button *ngIf="isAdmin || doWhat.canDelete" type="button" class="red-button" (click)="deleteCampaign()">{{ 'DELETE' | translate }}</button>
            </div>
          </div>
          <h1 class="details-heading">{{ campaignData.name }}</h1>
          <h3 class="details-subheading">{{ campaignData.platform | P_CampaignPlatformTitle:instance.isAltLayout }}</h3>
          <h4 class="details-client-row">
            <a class="details-client-link" [routerLink]="getClientDetailsRouterLink()" title="{{ 'VIEW' | translate }} {{ 'CLIENT' | translate }} {{ 'DETAILS' | translate }}">
              <ng-container *ngIf="instance.isAltLayout; else nonAltClientName">
                {{ campaignData?.client?.lastName }}
              </ng-container>
              <ng-template #nonAltClientName>
                <ng-container *ngIf="instance.isLastNameFirst; else firstLast">
                  {{ campaignData?.client?.lastName }} {{ campaignData?.client?.firstName }}
                </ng-container>
                <ng-template #firstLast>
                  {{ campaignData?.client?.firstName }} {{ campaignData?.client?.lastName }}
                </ng-template>
              </ng-template>
            </a>
            <button *ngIf="campaignData?.client?.email && !isExternal && !instance.isAltLayout" type="button" class="details-inline-link" (click)="openSendEmailModal()" aria-label="Send email">
              <i-feather name="mail" class="details-inline-icon"></i-feather>
            </button>
          </h4>
          <div class="row row-gap-4 d-flex align-items-stretch justify-content-center details-summary-grid">
            <div class="col-12" *ngIf="isTiered && !instance.isAltLayout">
              <div class="tier-banner details-tier-banner" [ngClass]="tierBannerClass" role="status">
                  <h3 class="tier-banner__title details-tier-title">{{ tierName | P_TierName }}</h3>
              </div>
            </div>
            <div *ngIf="!instance.isAltLayout" class="location_info col-12" [ngClass]="(isExternal) ? 'col-xl-4' : 'col-xl-3'">
              <div class="card details-card">
                <h5 class="card-title">{{ 'LOCATION_INFO' | translate }}:</h5>
                <div class="card-body">
                  <p><strong>{{ 'ADDRESS' | translate }}:</strong><br />
                    {{ campaignData?.street }}
                    <ng-container *ngIf="campaignData?.city || campaignData?.state || campaignData?.zipcode">
                      <br />
                    </ng-container>
                    {{ campaignData?.city }}<ng-container *ngIf="campaignData?.city && campaignData?.state">, </ng-container>{{ campaignData?.state }} {{ campaignData?.zipcode }}
                  </p>
                  <p><strong>{{ 'EMAIL' | translate }}:</strong> {{campaignData?.locationEmail}}</p>
                  <p><strong>{{ 'PHONE' | translate }}:</strong> {{campaignData?.locationPhone}}</p>
                  <p *ngIf="campaignData?.studioStatus"><strong>{{ 'STUDIO_STATUS' | translate }}:</strong> {{ campaignData?.studioStatus | P_CampaignStudioStatus }}</p>
                  <p> <span *ngIf="campaignData?.crmName"><strong>{{ 'CRM' | translate }}:</strong> {{campaignData?.crmName}}<br /></span>
                  <span *ngIf="campaignData?.crmId"><strong>{{ 'CRM_ID' | translate }}:</strong> {{campaignData?.crmId}}</span></p>

                  <p *ngIf="((isClientOwner || isEmployee || isAdmin) && tierName == 'Basic Tier')"><button class="red-button" (click)="openCreateTaskExternalModal()">{{ 'SEND_REQUEST' | translate }}</button></p>
                </div>
              </div>
            </div>
            <div class="col-12" [ngClass]="(isExternal) ? 'col-xl-4' : 'col-xl-3'">
              <div class="card details-card">
                <h5 class="card-title">{{ 'CAMPAIGN_INFO' | translate }}:</h5>
                <div class="card-body">
                  <p *ngIf="instance.isAltLayout"><strong>{{ 'REACH_CAMPAIGN_ID' | translate }}:</strong> {{ campaignData?.campaignId }}</p>
                  <p *ngIf="!isExternal || tierName !== 'Basic Tier'"><strong>{{ 'DMS' | translate }}:</strong> {{ campaignData?.dmsName }}</p>
                  <p><strong>{{ 'STAGE' | translate }}:</strong> {{ campaignData?.stageId | P_CampaignStageTitle }}</p>
                  <p *ngIf="!instance.isAltLayout"><strong>{{ 'ACTIVE_SUBSCRIPTION' | translate }}:</strong> {{ campaignData.subscriptionActive | P_Boolean }}</p>
                  <div *ngIf="((!isExternal && (mostRecentOrder !== {})) && !instance.isAltLayout)" class="details-inline-meta">
                    <strong>{{ 'MOST_RECENT_ORDER_STATUS' | translate }}:</strong>
                    <p [innerHTML]="mostRecentOrder.status" class="details-inline-meta__value"></p>
                  </div>
                  <div class="details-section" *ngIf="!isExternal" >
                    <strong>{{ 'AD_ACCOUNT_INFO' | translate }} ({{ campaignData.platform }}):</strong>
                    <div id="adAccounts" *ngIf="campaignData?.campaignAdAccounts?.length != 0">
                      <div class="ad-accounts-header">
                        <div class="ad-account-column"><strong>{{ 'AD_ACCOUNT_ID' | translate }}</strong></div>
                        <div class="ad-account-column"><strong>{{ 'AD_CAMPAIGN_ID' | translate }}</strong></div>
                        <div class="ad-account-column"><strong>{{ 'AD_LABEL' | translate }}</strong></div>
                      </div>
                    
                      <div *ngFor="let ad of campaignData.campaignAdAccounts" class="ad-accounts-row">
                        <div class="ad-account-column">{{ad.platformAccountID}}</div>
                        <div class="ad-account-column">{{ad.platformCampaignID}}</div>
                        <div class="ad-account-column">{{ad.adLabel}}</div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="campaignData?.employees?.length !== 0" class="details-section details-section--spaced employee-users">
                    <strong>{{ 'EMPLOYEE_USERS' | translate }}:</strong>
                    <span *ngFor="let e of campaignData.employees; let last = last">
                      <ng-container *ngIf="instance.isLastNameFirst; else firstLast">
                        {{ e?.lastName }} {{ e?.firstName }}<ng-container *ngIf="!last">, </ng-container>
                      </ng-container>
                      <ng-template #firstLast>
                        {{ e?.firstName }} {{ e?.lastName }}<ng-container *ngIf="!last">, </ng-container>
                      </ng-template>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 " [ngClass]="(isExternal) ? 'col-xl-4' : 'col-xl-3'">
              <div class="card details-card">
                <h5 class="card-title">{{ 'CAMPAIGN_KPIS' | translate }}:</h5>
                <div class="card-body">
                  <div *ngIf="!isExternal && !instance.isAltLayout">
                    <p class="details-centered-action"><button class="blue-button" (click)="openCampaignAnalysisModal()">{{ 'HOWS_MY_CAMPAIGN_DOING' | translate }}</button></p>
                  </div>
                  <div class="details-kpi-loading" *ngIf="campaignKpiLoading">{{ 'LOADING' | translate }}...</div>
                  <div class="details-kpi-error" *ngIf="!campaignKpiLoading && campaignKpiError">{{ campaignKpiError }}</div>
                  <div class="details-kpi-currency-note" *ngIf="!campaignKpiLoading && !campaignKpiError && campaignKpiCurrencyMixed">
                    KPI values use multiple currencies and should be reviewed by currency.
                  </div>
                  <div class="details-kpi-table-wrap" *ngIf="!campaignKpiLoading && !campaignKpiError && campaignKpiPeriods.length">
                    <table class="details-kpi-table">
                      <thead>
                        <tr>
                          <th>{{ 'METRIC' | translate }}</th>
                          <th *ngFor="let period of campaignKpiPeriods">{{ (period.key === 'last_7_days' ? 'LAST_7_DAYS' : 'LAST_30_DAYS') | translate }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><th>{{ 'IMPRESSIONS' | translate }}</th><td *ngFor="let period of campaignKpiPeriods">{{ campaignKpiValue(period.impressions, 'number') }}</td></tr>
                        <tr><th>{{ 'CLICKS' | translate }}</th><td *ngFor="let period of campaignKpiPeriods">{{ campaignKpiValue(period.clicks, 'number') }}</td></tr>
                        <tr><th>{{ 'CTR' | translate }}</th><td *ngFor="let period of campaignKpiPeriods">{{ campaignKpiValue(period.ctr, 'percent') }}</td></tr>
                        <tr *ngIf="isGoogleCampaign()"><th>{{ 'CPC' | translate }}</th><td *ngFor="let period of campaignKpiPeriods">{{ campaignKpiValue(period.cpc, 'currency') }}</td></tr>
                        <tr *ngIf="!isGoogleCampaign()"><th>{{ 'CPM' | translate }}</th><td *ngFor="let period of campaignKpiPeriods">{{ campaignKpiValue(period.cpm, 'currency') }}</td></tr>
                        <tr><th>{{ campaignKpiConversionLabel() }}</th><td *ngFor="let period of campaignKpiPeriods">{{ campaignKpiValue(period.conversion_total, 'number') }}</td></tr>
                        <tr><th>{{ campaignKpiConversionMode === 'leads' ? ('LSR' | translate) : ('CONVERSION_RATE' | translate) }}</th><td *ngFor="let period of campaignKpiPeriods">{{ campaignKpiValue(period.conversion_rate, 'percent') }}</td></tr>
                        <tr><th>{{ campaignKpiConversionMode === 'leads' ? ('CPL' | translate) : ('COST_PER_ACTION' | translate) }}</th><td *ngFor="let period of campaignKpiPeriods">{{ campaignKpiValue(period.cpl, 'currency') }}</td></tr>
                        <tr><th>{{ 'SPEND' | translate }}</th><td *ngFor="let period of campaignKpiPeriods">{{ campaignKpiValue(period.cost, 'currency') }}</td></tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="!isExternal" class="col-12 col-xl-3">
              <div class="card details-card">
                <h5 class="card-title">{{ 'INTERNAL_INFO' | translate }}:</h5>
                <div class="card-body newlines">
                  <p *ngIf="!instance.isAltLayout"><strong>{{ 'REACH_CAMPAIGN_ID' | translate }}:</strong> {{ campaignData?.campaignId }}</p>
                  <p><strong>{{ 'CAMPAIGN_NOTES' | translate }}:</strong><br *ngIf="campaignData?.opportunityNotes" />
                    {{ campaignData.opportunityNotes }}
                  </p>
                  <div *ngIf="!instance.isAltLayout">
                    <button class="blue-button m-1 ms-0" (click)="openLpRequestModal()">{{ 'LP_REQUEST' | translate }}</button>
                    <button class="blue-button m-1 ms-0" (click)="openTechRequestModal()">{{ 'TECH_REQUEST' | translate }}</button>
                    <button class="blue-button m-1 ms-0" (click)="openStrategyReviewModal()">{{ 'STRATEGY_REVIEW' | translate }}</button>
                    <button class="blue-button m-1 ms-0" (click)="openCreativeRequestModal()">{{ 'COPY_CREATIVE_REQUEST' | translate }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dv-custom-navs">
          <ul ngbNav #nav="ngbNav" [(activeId)]="active" (activeIdChange)="onActiveTabChange($event)" class="nav-tabs details-nav-tabs">
            <li [ngbNavItem]="1" [class.rm-tab-active]="active === 1" *ngIf="isTabVisible(1)">
              <a ngbNavLink>
                <i-feather name="paperclip"></i-feather><label>{{ 'NOTES' | translate }}</label>
              </a>
              <ng-template ngbNavContent>
                <div class="details-tab-panel">
                  <div class="details-tab-panel__surface details-tab-surface details-tab-surface--notes">
                    <app-notes [iCanDelete]="isAdmin || (roleOptions.notes && roleOptions.notes.canDelete)"
                      [iCanWrite]="isAdmin || (roleOptions.notes && roleOptions.notes.canWrite)" [iIsAdmin]="isAdmin"
                      [iIsExternal]="isExternal" [iHideActionColName]="true" [isGooglePlatform] = "campaignData.platform == 'Google'" [iParentId]="campaignData.id" [iType]="1">
                    </app-notes>
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="2" [class.rm-tab-active]="active === 2" *ngIf="isTabVisible(2)">
              <a ngbNavLink>
                <i-feather name="list"></i-feather><label>{{ 'TASKS' | translate }}</label>
              </a>
              <ng-template ngbNavContent>
                <div class="details-tab-panel">
                  <div class="details-tab-panel__surface details-tab-surface">
                    <div class="details-tab-toolbar">
                      <div fxLayout="row" fxLayoutAlign="start center" class="details-tab-toolbar__controls">
                        <button type="button" class="gray-button gray-button--toggle details-task-filter-button">
                          <label class="gray-button__toggle-content" for="showMyTasksCheckbox">
                              <input type="checkbox" id="showMyTasksCheckbox" [(ngModel)]="showOnlyMyTasks" (change)="onShowMyTasksChange()" value="Show Only My Tasks">
                              {{ 'SHOW_ONLY_MY_TASKS' | translate }}
                          </label>
                        </button>
                      </div>
                      <div class="details-tab-toolbar__actions">
                        <button *ngIf="!instance.isAltLayout" class="blue-button details-tab-toolbar__button" type="button" (click)="onCampaignCheck()">
                          {{ 'CAMPAIGN_CHECK' | translate }}
                        </button>
                        <button class="blue-button" type="button" (click)="onAddTask()">{{ 'ADD_TASK' | translate }}</button>
                      </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="details-task-filters">
                      <div fxLayout="row" fxLayoutAlign="start center" class="details-task-toggle-group">
                        <div (click)="changeShowTasks()" class="details-task-toggle-shell">
                          <h2 class="details-task-toggle" [class.is-active]="showTasks">{{ 'TO_DO' | translate }}</h2>
                        </div>
                        <div (click)="changeShowCompletedTasks()" class="details-task-toggle-shell">
                          <h2 class="details-task-toggle" [class.is-active]="showCompletedTasks">{{ 'COMPLETED' | translate }}</h2>
                        </div>
                      </div>
                    </div>
                    <app-tasks-datatable *ngIf="showTasks" 
                      [iCanRead]="isAdmin || (roleOptions.tasks && roleOptions.tasks.canRead)"
                      [iCanWrite]="isAdmin || (roleOptions.tasks && roleOptions.tasks.canWrite)"
                      [iCanDelete]="isAdmin || (roleOptions.tasks && roleOptions.tasks.canDelete)"
                      (oRowClick)="onTaskRowClick($event)" 
                      [iSortColumn]="'title'" 
                      [iColumns]="columnsTasks"
                      [iHideHeaderActions]="true"
                      [iShowActions]="false" 
                      [iShowExport]="false"
                      [iShowSelect]="false"
                      [iData$]="tasksData">
                    </app-tasks-datatable>
                    <app-tasks-datatable *ngIf="showCompletedTasks" 
                      [iCanRead]="isAdmin || (roleOptions.tasks && roleOptions.tasks.canRead)"
                      [iCanWrite]="isAdmin || (roleOptions.tasks && roleOptions.tasks.canWrite)"
                      [iCanDelete]="isAdmin || (roleOptions.tasks && roleOptions.tasks.canDelete)"
                      (oRowClick)="onTaskRowClick($event)" 
                      [iSortColumn]="'completedOn'" 
                      [iSortDirection]="'desc'"
                      [iColumns]="completedTasksColumns" 
                      [iHideHeaderActions]="true"
                      [iShowActions]="false" 
                      [iShowExport]="false"
                      [iShowSelect]="false"
                      [iData$]="completedTasksData" 
                      [isCompleted]="true">
                    </app-tasks-datatable>
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="3" [class.rm-tab-active]="active === 3" *ngIf="isTabVisible(3)">
              <a ngbNavLink>
                <i-feather name="refresh-cw"></i-feather><label>{{ 'SUBSCRIPTIONS' | translate }}</label>
              </a>
              <ng-template ngbNavContent>
                <div class="details-tab-panel">
                  <div class="details-tab-panel__surface details-tab-surface details-tab-surface--tight">
                    <app-subscription-shared [iCampaignId]="campaignData.id" [iClientId]="campaignData?.client?.id">
                    </app-subscription-shared>
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="4" [class.rm-tab-active]="active === 4" *ngIf="isTabVisible(4)">
              <a ngbNavLink>
                <i-feather name="file-text"></i-feather><label>{{ 'ORDERS' | translate }}</label>
              </a>
              <ng-template ngbNavContent>
                <div class="details-tab-panel">
                  <div class="details-tab-panel__surface details-tab-surface details-tab-surface--tight">
                    <app-campaign-datatable
                      [iCanRead]="ordersPermissions.canRead" [iShowViewAction]="false" [iColumns]="orderColumns"
                      [iHideHeaderActions]="false" [iRowLinkHandler]="getOrderRowLink" [iData$]="ordersData"
                      [iShowSelect]="false" iSortColumn="numericId" [iShowExport]="false" [iShowEditAction]="false" [iHideHeaderActions]="false" [iTotalCount]="ordersData.length" 
                      iSortDirection="desc">
                    </app-campaign-datatable>
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="5" [class.rm-tab-active]="active === 5" *ngIf="isTabVisible(5)">
              <a ngbNavLink>
                <i-feather name="bar-chart-2"></i-feather><label>{{ 'LEADS' | translate }}</label>
              </a>
              <ng-template ngbNavContent>
                <div class="details-tab-panel">
                  <div class="details-tab-panel__surface details-tab-surface details-tab-surface--tight">
                    <app-campaign-datatable [iCanRead]="leadsPermissions.canRead" [iCanWrite]="leadsPermissions.canWrite" [iCanDelete]="leadsPermissions.canDelete"
                        [iColumns]="leadsColumns" (oDeleteRows)="onDelete($event)" [iRowLinkHandler]="getRowLink"
                        [iTotalCount]="leadsTotalCount" [iHideHeaderActions]="true" [iShowEditAction]="false"
                        [iData$]="leadsData" (oLoadDataFromServer)="onLoadingData($event)" [iShowSelect]="false"
                        iSortColumn="createdAt" iSortDirection="desc" [iShowSelect]="true">
                    </app-campaign-datatable>
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="6" [class.rm-tab-active]="active === 6" *ngIf="isTabVisible(6)">
              <a ngbNavLink>
                <i-feather name="layout"></i-feather><label>{{ 'REPORTS' | translate }}</label>
              </a>
              <ng-template ngbNavContent>
                <div class="details-tab-panel">
                  <div class="details-tab-panel__surface details-tab-surface details-tab-surface--report">
                    <app-report-view></app-report-view>
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="7" [class.rm-tab-active]="active === 7" *ngIf="isTabVisible(7)">
              <a ngbNavLink>
                <i-feather name="tag"></i-feather><label>{{ 'TAGS' | translate }}</label>
              </a>
              <ng-template ngbNavContent>
                <div class="details-tab-panel">
                  <div class="details-tab-panel__surface details-tab-surface details-tab-surface--notes">
                    <app-tags-tab [iCanWrite]="isAdmin || (roleOptions.tags && roleOptions.tags.canWrite)"
                      [iParentId]="campaignData.id" [iType]="1"></app-tags-tab>
                  </div>
                </div>
              </ng-template>
            </li>
            <li [ngbNavItem]="8" [class.rm-tab-active]="active === 8" *ngIf="isTabVisible(8)">
              <a ngbNavLink>
                <i-feather name="file-text"></i-feather><label>{{ 'AUDIT' | translate }}</label>
              </a>
              <ng-template ngbNavContent>
                <div class="details-tab-panel">
                  <div class="details-tab-panel__surface details-tab-surface details-tab-surface--tight">
                    <div class="row campaignAudit">
                      <div class="col">
                        <app-campaign-audit [iCanWrite]="isAdmin || (roleOptions.audit && roleOptions.audit.canWrite)" [iCampaignId]="campaignData.id"></app-campaign-audit>
                      </div>
                      <div class="col">
                        <app-campaign-budget-audit [iCampaignId]="campaignData.id"></app-campaign-budget-audit>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </li>
          </ul>
          <div class="details-nav-outlet" [ngbNavOutlet]="nav"></div>
        </div>
      </div>
    </div>
</div>
